// extracted by mini-css-extract-plugin
export default {"container":"applicants_container__SwGZf","title":"applicants_title__GdHbr","notFoundContainer":"applicants_notFoundContainer__Px-qg","list":"applicants_list__Rx39t"};